import styled, { createGlobalStyle } from "styled-components";
import { FontWeights, getTheme, IButtonStyles, ILabelStyles, IModalStyles, mergeStyleSets } from "@fluentui/react";

const theme = getTheme();

export const AccessRequestsModalGlobalStyle = createGlobalStyle`
    .access-requests-modal.ms-Dialog .ms-Dialog-main,
    .access-requests-modal .ms-Dialog-main
    {
        width: min(85vw, 1400px) !important;
        max-width: 95vw !important;
        min-width: min(85vw, 800px) !important;
        max-height: 85vh !important;
        display: flex !important;
        flex-direction: column !important;
        overflow: hidden !important;
        min-height: 0;
    }

    @media screen and (max-width: 859px)
    {
        .access-requests-modal.ms-Dialog .ms-Dialog-main,
        .access-requests-modal .ms-Dialog-main
        {
            min-width: unset !important;
            width: 95vw !important;
        }
    }

    .access-requests-toolbar-button.tiny-secondary-button:focus,
    .access-requests-toolbar-button.tiny-secondary-button:focus-visible
    {
        background: #ffffff !important;
        border-color: #cc214f !important;
        color: #cc214f !important;
        outline: none !important;
    }

    .access-requests-modal .ms-Pivot-panel,
    .access-requests-modal .ms-Pivot [role="tabpanel"]
    {
        padding-left: 8px;
        padding-right: 8px;
        box-sizing: border-box;
        max-height: min(52vh, 560px);
        overflow-y: auto;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .access-requests-modal .ms-Pivot [role="tabpanel"] thead th
    {
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: #f5f7f9;
        box-shadow: 0 1px 0 #e9eff2;
    }
`;

export const accessRequestsModalFluentStyles: Partial<IModalStyles> =
{
    main:
    {
        maxWidth: "min(92vw, 1400px)",
        width: "min(92vw, 1400px)",
        maxHeight: "92vh",
    },
};

export const accessRequestsModalTitleLabelStyles: Partial<ILabelStyles> =
{
    root:
    {
        fontSize: "24px !important",
        lineHeight: "1.3",
        fontWeight: FontWeights.semibold,
        padding: "0 32px",
        margin: "0",
        textAlign: "center",
        width: "100%",
    },
};

export const accessRequestsModalContentStyles = mergeStyleSets(
{
    container:
    {
        display: "flex",
        flexFlow: "column nowrap",
        alignItems: "stretch",
        borderRadius: "2em",
        width: "100%",
        maxWidth: "100%",
        flex: "1 1 auto",
        minHeight: 0,
        maxHeight: "85vh",
        overflow: "hidden",
    },
    header:
    [
        theme.fonts.xLargePlus,
        {
            flex: "0 0 auto",
            color: "#CC214F",
            display: "flex",
            alignItems: "center",
            fontWeight: FontWeights.semibold,
            padding: "12px 12px 14px 24px",
        },
    ],
    body:
    {
        textAlign: "left",
        flex: "1 1 auto",
        minHeight: 0,
        padding: "0 24px 8px 24px",
        overflowX: "hidden",
        overflowY: "hidden",
        maxHeight: "min(78vh, 880px)",
        cursor: "default",
        display: "flex",
        flexDirection: "column",
    },
});

/** Contador integrado dentro del botón «Solicitudes de acceso». */
export const AccessRequestsCountInline = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 8px;
    border-radius: 11px;
    background-color: #cc214f;
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    font-variant-numeric: tabular-nums;
`;

export const accessRequestsTriggerButtonStyles: Partial<IButtonStyles> =
{
    root:
    {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
    },
    flexContainer:
    {
        display: "flex",
        alignItems: "center",
        columnGap: "10px",
        rowGap: "4px",
    },
};

export const AccessRequestsTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 8px;
    cursor: default;
    font-size: 14px;

    th, td
    {
        padding: 10px 8px;
        text-align: left;
        border-bottom: 1px solid #e9eff2;
        vertical-align: middle;
    }

    th
    {
        color: #2a4143;
        font-weight: 600;
        background-color: #f5f7f9;
    }

    td
    {
        color: #5f7172;
    }

    .actions-cell
    {
        white-space: nowrap;
        text-align: center;
        vertical-align: middle;
        padding-top: 8px;
        padding-bottom: 8px;
    }

    .readonly
    {
        cursor: default;
    }
`;

export const PivotWrap = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    margin-bottom: 8px;
    overflow: hidden;

    .ms-Pivot-text
    {
        font-weight: 600;
    }
`;

export const ActionButtonsWrap = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 8px;
    vertical-align: middle;
`;

/** Botones compactos para celdas de tabla (sin márgenes del styleDefButton global). */
export const accessRequestsTableActionButtonDef: Partial<IButtonStyles> =
{
    root:
    {
        margin: 0,
        minHeight: "32px",
        height: "32px",
        boxSizing: "border-box",
        cursor: "pointer",
        background: "#CC214F",
        fontFamily: "Barlow, sans-serif",
        fontStyle: "normal",
        fontWeight: "600",
        fontSize: "13px",
        lineHeight: "20px",
        textAlign: "center",
        color: "#FFFFFF",
        borderRadius: "100px",
        padding: "4px 14px",
        borderStyle: "none",
    },
    flexContainer:
    {
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
    },
};

export const accessRequestsTableActionButtonCancel: Partial<IButtonStyles> =
{
    root:
    {
        margin: 0,
        minHeight: "32px",
        height: "32px",
        boxSizing: "border-box",
        cursor: "pointer",
        background: "transparent",
        fontFamily: "Barlow, sans-serif",
        fontStyle: "normal",
        fontWeight: "600",
        fontSize: "13px",
        lineHeight: "20px",
        textAlign: "center",
        color: "#CC214F",
        borderRadius: "100px",
        padding: "2px 14px",
        border: "2px solid #CC214F",
    },
    flexContainer:
    {
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
    },
};

export const AccessRequestsIntroText = styled.p`
    flex-shrink: 0;
    margin: 0 0 8px 0;
    color: #5f7172;
    font-size: 14px;
    line-height: 1.4;
`;

export const AccessRequestsDecisionErrorText = styled.p`
    margin: 0 0 12px 0;
    color: #a4262c;
    font-size: 14px;
    line-height: 1.4;
`;

export const AccessRequestsLoadingWrap = styled.div`
    display: flex;
    justify-content: center;
    padding: 24px;
`;

export const AccessRequestsHistoryEmptyCell = styled.td`
    text-align: center;
    color: #5f7172;
    padding: 16px;
`;

export const AccessRequestsEmptyMessage = styled.p`
    margin: 0;
    padding: 16px 0;
    color: #5f7172;
    font-size: 14px;
    line-height: 1.4;
`;

/** Mensaje cuando no hay solicitudes pendientes */
export const AccessRequestsEmptyPendingMessage = styled.p`
    margin: 0;
    padding: 24px 16px;
    color: #5f7172;
    font-size: 14px;
    line-height: 1.4;
    text-align: center;
    width: 100%;
`;

export const AccessRequestsSectionTitle = styled.h3`
    margin-top: 1rem !important;
    margin-bottom: 0 !important;
    margin-left: 0;
    padding-left: 12px;
    font-size: 15px;
    font-weight: 600;
    color: #2a4143;

    &:first-of-type
    {
        margin-top: 8px;
    }
`;

export const AccessRequestsModalFooter = styled.div`
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    padding: 10px 24px 16px 24px;
`;

/** Área con scroll para contenido alto (firma SMS) dentro del cuerpo del modal. */
export const AccessRequestsModalScrollArea = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    max-height: min(52vh, 560px);
    overflow-y: auto;
    overflow-x: auto;
    margin-top: 8px;
    -webkit-overflow-scrolling: touch;
`;

/** Contenedor del flujo SMS (SignatureComponent) en solicitudes de acceso. */
export const AccessRequestsSignatureWrap = styled.div`
    width: 100%;
    margin-top: 0;

    h2
    {
        font-size: 20px;
    }

    & main .column-count
    {
        opacity: 1 !important;
        flex-shrink: 0;
        min-width: 5.5rem;
    }

    & main .column-count > p
    {
        font-size: clamp(2.5rem, 6vw, 3.75rem) !important;
        line-height: 1.1 !important;
        font-weight: 600;
        color: ${props => props.theme?.palette?.black || "#2A4143"};
        opacity: 1 !important;
    }
`;